import { GiAtom } from "react-icons/gi";
import PropTypes from "prop-types";

export const AtomAssistLogo = (props) => {
  return (
    <div
      style={{
        position: "absolute",
        top: "40%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        width: "100%",
        zIndex: -1,
      }}
    >
      <div>
        <h2 style={{ color: "lightgray" }}>
          Atom <GiAtom className="aaIcon" color="lightgray" />
          Assist
        </h2>
      </div>
      <div>
        <h4 style={{ color: "lightgray" }}>{props.lowerMessage}</h4>
      </div>
    </div>
  );
};

AtomAssistLogo.propTypes = {
  lowerMessage: PropTypes.string,
};

export default AtomAssistLogo;
